import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import CourtPlanLogo from '../components/CourtPlanLogo';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Λείπει ο σύνδεσμος επιβεβαίωσης.');
      return;
    }
    axios.post(`${API}/auth/verify-email`, { token })
      .then(({ data }) => {
        setStatus('success');
        setMessage(`Το email ${data.email} επιβεβαιώθηκε με επιτυχία!`);
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Μη έγκυρος ή ληγμένος σύνδεσμος επιβεβαίωσης.');
      });
  }, [params]);

  return (
    <div className="min-h-screen bg-[#f7f2e7] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <CourtPlanLogo size="md" />
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8 text-center" data-testid="verify-email-card">
          {status === 'loading' && (
            <>
              <Loader2 className="w-10 h-10 text-red-700 animate-spin mx-auto mb-4" />
              <p className="text-slate-700 text-sm">Επιβεβαίωση email σε εξέλιξη…</p>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle2 className="w-12 h-12 text-green-600 mx-auto mb-4" data-testid="verify-success-icon" />
              <h1 className="text-lg font-semibold text-slate-900 mb-2">Ο λογαριασμός σας ενεργοποιήθηκε</h1>
              <p className="text-sm text-slate-600 mb-6" data-testid="verify-success-message">{message}</p>
              <Link
                to="/login"
                className="inline-block w-full h-11 leading-[44px] bg-red-700 hover:bg-red-800 text-white font-semibold rounded-lg transition-all"
                data-testid="verify-go-login-btn"
              >
                ΣΥΝΔΕΣΗ
              </Link>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="w-12 h-12 text-red-600 mx-auto mb-4" data-testid="verify-error-icon" />
              <h1 className="text-lg font-semibold text-slate-900 mb-2">Η επιβεβαίωση απέτυχε</h1>
              <p className="text-sm text-slate-600 mb-6" data-testid="verify-error-message">{message}</p>
              <Link to="/login" className="text-sm text-red-700 font-medium hover:underline" data-testid="verify-back-login-link">
                Επιστροφή στη σύνδεση
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
